import api from "./api";

export const getGPTSettings = async () => {
  try {
    const { data } = await api.get("/gpt/settings");
    return data;
  } catch (error) {
    // Re-throw with more context for better error handling
    if (error.message && error.message.includes("Network Error")) {
      throw new Error("Unable to connect to server. Please check if the backend is running.");
    }
    throw error;
  }
};

export const updateGPTSettings = async (settings) => {
  try {
    const { data } = await api.post("/gpt/settings", settings);
    return data;
  } catch (error) {
    if (error.message && error.message.includes("Network Error")) {
      throw new Error("Unable to save settings. Please check your connection and try again.");
    }
    throw error;
  }
};

export const getGPTSuggestions = async (ticketId, message = null, customPrompt = null) => {
  try {
    const { data } = await api.post(`/gpt/suggest/${ticketId}`, { message, customPrompt });
    return data;
  } catch (error) {
    if (error.message && error.message.includes("Network Error")) {
      throw new Error("Unable to get GPT suggestions. Please check your connection.");
    }
    throw error;
  }
};

export const analyzeMessage = async (message, ticketId = null) => {
  try {
    const { data } = await api.post("/gpt/analyze-message", { message, ticketId });
    return data;
  } catch (error) {
    if (error.message && error.message.includes("Network Error")) {
      throw new Error("Unable to analyze message. Please check your connection.");
    }
    throw error;
  }
};

export const generateConversationSummary = async (ticketId, summaryType = "short", systemLanguage = null) => {
  try {
    const params = { summaryType };
    if (systemLanguage) {
      params.systemLanguage = systemLanguage;
    }
    const { data } = await api.get(`/gpt/summary/${ticketId}`, {
      params
    });
    return data;
  } catch (error) {
    if (error.message && error.message.includes("Network Error")) {
      throw new Error("Unable to generate summary. Please check your connection.");
    }
    throw error;
  }
};

export const detectSalesOpportunities = async (ticketId, systemLanguage = null) => {
  try {
    const params = {};
    if (systemLanguage) {
      params.systemLanguage = systemLanguage;
    }
    const { data } = await api.get(`/gpt/sales-opportunities/${ticketId}`, {
      params
    });
    return data;
  } catch (error) {
    if (error.message && error.message.includes("Network Error")) {
      throw new Error("Unable to detect sales opportunities. Please check your connection.");
    }
    throw error;
  }
};

export const getAgentPerformance = async (userId, startDate = null, endDate = null, ticketIds = null, delayThreshold = null) => {
  try {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (ticketIds) params.ticketIds = Array.isArray(ticketIds) ? ticketIds.join(",") : ticketIds;
    if (delayThreshold) params.delayThreshold = delayThreshold;
    
    const { data } = await api.get(`/gpt/agent-performance/${userId}`, { params });
    return data;
  } catch (error) {
    if (error.message && error.message.includes("Network Error")) {
      throw new Error("Unable to get agent performance. Please check your connection.");
    }
    throw error;
  }
};

export const getSentimentTrends = async (ticketId, systemLanguage = null) => {
  try {
    const params = {};
    if (systemLanguage) {
      params.systemLanguage = systemLanguage;
    }
    const { data } = await api.get(`/gpt/sentiment-trends/${ticketId}`, {
      params
    });
    return data;
  } catch (error) {
    if (error.message && error.message.includes("Network Error")) {
      throw new Error("Unable to get sentiment trends. Please check your connection.");
    }
    throw error;
  }
};

export const getDepartmentPerformance = async (queueId = null, startDate = null, endDate = null, delayThreshold = null) => {
  try {
    const params = {};
    if (queueId) params.queueId = queueId;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (delayThreshold) params.delayThreshold = delayThreshold;
    const { data } = await api.get("/gpt/department-performance", { params });
    return data;
  } catch (error) {
    if (error.message && error.message.includes("Network Error")) {
      throw new Error("Unable to get department performance. Please check your connection.");
    }
    throw error;
  }
};

export const detectKeyIssues = async (startDate = null, endDate = null, ticketIds = null, limit = null, systemLanguage = null) => {
  try {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (ticketIds) params.ticketIds = Array.isArray(ticketIds) ? ticketIds.join(",") : ticketIds;
    if (limit) params.limit = limit;
    if (systemLanguage) params.systemLanguage = systemLanguage;
    
    const { data } = await api.get("/gpt/key-issues", { params });
    return data;
  } catch (error) {
    if (error.message && error.message.includes("Network Error")) {
      throw new Error("Unable to detect key issues. Please check your connection.");
    }
    throw error;
  }
};










